/**
 * React ↔ Datafeed bridge.
 *
 * The Datafeed is a plain JS object instantiated outside React, but
 * `resolveSymbol` needs metadata that lives in component props. This
 * module is the sole module-level mutable state in the package:
 * everything else is per-widget-instance.
 *
 * `TradingViewWidget` calls `registerSymbol` on mount (writing the symbol
 * metadata into a map keyed by TVSymbolId) and invokes the returned dispose
 * fn on unmount. The Datafeed reads from the same map synchronously inside
 * `resolveSymbol`.
 *
 * `inline:` mode (mobile-on-web wrappers) uses the same registry to bridge
 * prefetched `Bar[]` payloads into `getBars` without a second code path.
 */
const registry = new Map();
export function registerSymbol(symbolId, meta) {
    registry.set(symbolId, meta);
    return () => {
        if (registry.get(symbolId) === meta) {
            registry.delete(symbolId);
        }
    };
}
export function getSymbolMeta(symbolId) {
    return registry.get(symbolId);
}
/** Test-only: clear the registry between cases. Not exported from `index.ts`. */
export function __resetSymbolRegistryForTests() {
    registry.clear();
}
